export enum PianoMode {
  Play,
  Quiz
}

export enum QuizStatus {
  Starting,
  InProgress,
  Finished,
  None
}

export enum Result {
  Correct,
  Incorrect,
  None
}